<script lang="ts" setup>
import { computed } from 'vue'
import IconHome from '@/components/icons/IconHome.vue'
import IconInsights from '@/components/icons/IconInsights.vue'
import IconAutomations from '@/components/icons/IconAutomations.vue'
import IconSettings from '@/components/icons/IconSettings.vue'
import { useCurrentProperty } from '@/composables/use-current-property'
import { useFeatureFlag } from '@/composables/feature-flags'

export interface BottomBarComponentProps {
  propertyId?: number
}
const props = defineProps<BottomBarComponentProps>()
const insightsPath = computed(() => {
  if (props.propertyId) {
    return `/insights/${props.propertyId}`
  }
  return '/insights'
})

const { isPending, hasSolarbotOnCurrentProperty } = useCurrentProperty()
const hasSavingsFlag = useFeatureFlag('savings')

// HotBot-only properties have no Insights content without the savings flag.
// Keep the tab while properties load so it doesn't flicker for everyone else
const showInsights = computed(
  () =>
    isPending.value ||
    hasSolarbotOnCurrentProperty.value ||
    hasSavingsFlag.value
)
</script>

<template>
  <nav>
    <router-link to="/home">
      <IconHome />
      <span>Home</span>
    </router-link>
    <router-link v-if="showInsights" :to="insightsPath">
      <IconInsights />
      <span>Insights</span>
    </router-link>
    <router-link to="/automations">
      <IconAutomations class="automations" />
      <span>Automations</span>
    </router-link>
    <router-link to="/settings">
      <IconSettings />
      <span>Settings</span>
    </router-link>
  </nav>
</template>

<style lang="scss" scoped>
nav {
  display: flex;
  padding-top: 9px;
  justify-content: space-around;

  a {
    --icon-primary: var(--grey800);
    --icon-secondary: #43386040;

    &.router-link-exact-active {
      --icon-primary: var(--purple500);
      --icon-secondary: #d7ccf4;
      color: var(--purple500);
    }

    &:hover {
      color: var(--purple500);
    }
  }
}

a {
  font-size: var(--font-size-10);
  display: flex;
  justify-content: flex-end;
  flex-direction: column;
  align-items: center;
  gap: 6px;
}

.automations {
  margin-bottom: -5px;
}
</style>
